import { render } from "./TreatmentsTable.vue?vue&type=template&id=5af99a50"
import script from "./TreatmentsTable.vue?vue&type=script&lang=js"
export * from "./TreatmentsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__